import { render } from "./Real.vue?vue&type=template&id=3aaf278c&scoped=true"
import script from "./Real.vue?vue&type=script&lang=js"
export * from "./Real.vue?vue&type=script&lang=js"

import "./Real.vue?vue&type=style&index=0&id=3aaf278c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaf278c"]])

export default __exports__